// extracted by mini-css-extract-plugin
module.exports = {"main":"IconWarning__main--1ZRpo","colored":"IconWarning__colored--3Yp1U"};